import { useRef } from 'react';

const useBlur = ({ name, value, onBlur, disabled }) => {
  const ref = useRef();

  const handleBlur = !disabled ? (event) => {
    if (event && !ref.current.contains(event.relatedTarget)) {
      onBlur({
        target: {
          name,
          value,
        },
      });
    }
  } : null;

  return {
    ref,
    handleBlur,
  };
};

export { useBlur };
